/**
 * Title · Handwerker · Aufgabenart · Datum · Abgabefrist · Soll · Ist · Status
 *
 * Status sits last, the way it does in the Auftrag list: the row ends in the label-plus-dot pair,
 * and the dot has the row's right edge to sit against instead of crowding the next column.
 */
export const aufgabenColumns = "1fr 1fr 1fr 1.2fr 1fr 1.4fr 1.4fr 1.2fr 1.2fr";
